export default function genererCritereRechercheLigneCommande() {
  return {
    libelleProduit: null,
    libelle: null,
    auto: '',
    referenceProduit: null,
    villes: [],
    types: [],
    tiersId: [],
    typesProduits: [],
    typesDevisCommandeFacture: [],
    etatsDevisCommandeFacture: [],
    dateVisualisation: null,
    datesEtVenteDivers: {
      dateDebut: null,
      dateFin: null,
    },
    sens: null,
    commercialId: null,
    societeId: null,
    secteurIds: [],
    etat: [],
    code: null,
  };
}
